import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { EventSummary } from '@interfaces';


export function getColumns(util: UtilityService) {

	const formatUTC = (utc: number) => util.date.formatUTC(utc, 'MMM D, YYYY', 'H:MM AM EST', 'en-US')

	const columns: GridColumn<EventSummary, unknown>[] = [
		buildColumn(util, 'Id', row => row.eventId),
		buildColumn(util, 'Text', row => row.eventName, { header: 'Event Name' }),
		buildColumn(util, 'Text', row => row.courseLevelTitle, { header: 'Course Level' }),
		buildColumn(util, 'Text', row => formatUTC(row.startUTC), { header: 'Start Date', width: 80 }),
		buildColumn(util, 'Text', row => formatUTC(row.endUTC), { header: 'End Date', width: 80 }),
	];

	return columns;

}
